/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

function Transaction({ idx, currency, narration, entryType, amount, created }) {
  // const x = currency !== "N/A" ? currency : undefined;
  // const formatter = new Intl.NumberFormat(x, {
  //   style: "currency",
  //   currency: x !== undefined ? currency : "NGN",

  //   // These options are needed to round to whole numbers if that's what you want.
  //   // minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //   maximumFractionDigits: 2, // (causes 2500.99 to be printed as $2,501)
  // });

  function format(amt) {
    const prefix = amt < 0 ? "-" : "";
    amt = Math.abs(amt);
    return `${prefix}${currency}${amt.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }

  return (
    <MDBox key={idx} component="li" py={1} pr={2} mb={1}>
      <MDBox display="flex" justifyContent="space-between" alignItems="center">
        <MDBox display="flex" alignItems="center">
          <MDBox mr={2}>
            <MDButton
              variant="outlined"
              color={entryType === "DEBIT" ? "error" : "success"}
              iconOnly
              circular
            >
              <Icon sx={{ fontWeight: "bold" }}>{entryType === "DEBIT" ? "remove" : "add"}</Icon>
            </MDButton>
          </MDBox>
          <MDBox display="flex" flexDirection="column">
            <MDTypography variant="button" fontWeight="medium" gutterBottom>
              {narration}
            </MDTypography>
            <MDTypography variant="caption" color="text" fontWeight="regular">
              {created}
            </MDTypography>
          </MDBox>
        </MDBox>
        <MDTypography
          variant="button"
          color={entryType === "DEBIT" ? "error" : "success"}
          fontWeight="medium"
          textGradient
        >
          {format(amount / 100)}
        </MDTypography>
      </MDBox>
    </MDBox>
  );
}

// Typechecking props of the Transaction
Transaction.propTypes = {
  idx: PropTypes.node.isRequired,
  currency: PropTypes.node.isRequired,
  narration: PropTypes.string.isRequired,
  entryType: PropTypes.string.isRequired,
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  created: PropTypes.string.isRequired,
};

export default Transaction;
